<input id="darkMode" type="checkbox" [checked]="darkMode$ | async" (change)="onToggle()" class="toggle" />
<label class="toggle-label" for="darkMode">
    <i class="bi bi-moon-stars "></i>
</label>